import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'
import dayjs from 'dayjs'

import { ArrowActionCard } from '../ArrowActionCard'
import { SectionContainer, SectionTitle } from '@jelly/ui'

const SubTitle = styled.div`
	color: ${({ theme }) => theme.colors.gray[600]};
	margin-top: 0.5rem;
`
const FlexGrid = styled.div`
	align-items: stretch;
	display: flex;
	flex-direction: column;
	margin: 1rem -0.5rem -1rem -0.5rem;

	a {
		margin: 1rem 0.5rem;
	}

	${({ theme }) => theme.MQ.S} {
		flex-direction: row;
		flex-wrap: wrap;
	}

	${({ theme }) => theme.MQ.L} {
		flex-direction: row;
		flex-wrap: wrap;
	}
`
/**
 * Arrow Card Section that displays grid (using flex, ie11) of Arrow Action Cards
 *
 * @param {Array} props.listOfContent ::  list of content to display within Arrow Action Cards
 * @param {String} props.subTitle :: subtitle of this section
 * @param {String} props.title :: title of this section
 */
export function ArrowCardGridSection({ listOfContent, subTitle, title }) {
	return (
		<SectionContainer>
			<SectionTitle>{title} </SectionTitle>
			<SubTitle>{subTitle}</SubTitle>
			<FlexGrid>
				{listOfContent.map((bestPick, i) => {
					const { canonical, description, modified_at, published_at, title } = bestPick
					const isUpdated = dayjs(modified_at).isAfter(dayjs(published_at))
					const date = isUpdated ? modified_at : published_at
					return (
						<ArrowActionCard
							canonical={canonical}
							date={date}
							description={description}
							isUpdated={isUpdated}
							key={`bestpick-${i}`}
							title={title}
						/>
					)
				})}
			</FlexGrid>
		</SectionContainer>
	)
}

ArrowCardGridSection.propTypes = {
	listOfContent: array.isRequired,
	subTitle: string,
	title: string,
}
